/**
 * Brand-admin session: JWT lives in HttpOnly cookie (credentials: 'include').
 * Do not store AUTH_TOKEN in localStorage (XSS can steal it).
 */

export const AUTH_TOKEN_KEY = "AUTH_TOKEN";

export function stripJwtFromStorage() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

/** Prefer cookie auth; never attach a client-stored JWT. */
export function authHeaders(extra = {}) {
  return { ...extra };
}

export function withCredentials(init = {}) {
  const { headers, ...rest } = init;
  return {
    credentials: "include",
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(headers || {}),
    },
  };
}
